import { render, staticRenderFns } from "./set-event.vue?vue&type=template&id=2b6842a7&scoped=true&"
import script from "./set-event.vue?vue&type=script&lang=js&"
export * from "./set-event.vue?vue&type=script&lang=js&"
import style0 from "./set-event.vue?vue&type=style&index=0&id=2b6842a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6842a7",
  null
  
)

export default component.exports